import { BSpinner } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBSpinner when migrating. */
export const EgBSpinner = createEgBootstrapProxy("EgBSpinner", BSpinner);
